<template>
    <b-modal ref="modal" centered hide-header  no-close-on-backdrop no-close-on-esc hide-footer size="lg">
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('BUILDINGDETAILS')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group"  v-if="formData != null">
                <div class="form-row">
                    <div class="col-sm-2">
                        <b-form-fieldset v-bind:label="$t('OBJECTID')">
                            <inputvalidation :formerror="formError" name="objectId">
                            <b-form-input type="text" v-model="formData.objectId"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-5">
                        <b-form-fieldset v-bind:label="$t('CLIENTNAME')">
                            <inputvalidation :formerror="formError" name="clientName">
                            <b-form-input type="text" v-model="formData.clientName"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-5">
                        <b-form-fieldset v-bind:label="$t('ADDRESS')">
                            <inputvalidation :formerror="formError" name="address">
                            <b-form-input type="text" v-model="formData.address"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('POSTALCODE')">
                            <inputvalidation :formerror="formError" name="postalCode">
                            <b-form-input type="text" v-model="formData.postalCode"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('CITY')">
                            <inputvalidation :formerror="formError" name="city">
                            <b-form-input type="text" v-model="formData.city"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('CONTACTPERSON')">
                            <inputvalidation :formerror="formError" name="contactPerson">
                            <b-form-input type="text" v-model="formData.contactPerson"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('EMAIL')">
                            <inputvalidation :formerror="formError" name="email">
                            <b-form-input type="text" v-model="formData.email"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('PHONE')">
                            <inputvalidation :formerror="formError" name="phone">
                            <b-form-input type="text" v-model="formData.phone"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-sm-6" v-if="globals && globals.acl && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction">
                        <b-form-fieldset v-bind:label="$t('COMPANY')">
                            <inputvalidation :formerror="formError" name="companyId">
                                <b-form-select :options="userCompanies.root" v-model="formData.companyId" value-field="companyId" text-field="companyName">
                                </b-form-select>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-6">
                        <b-form-fieldset v-bind:label="$t('OBJECTDETAILS')">
                            <inputvalidation :formerror="formError" name="objectDetailIds">
                                <lbselect 
                                :empty="true"
                                :multiselect="true"
                                :list="objectDetails.root" 
                                :total-count="objectDetails.totalCount"
                                :pagination="objectDetailsPagination"
                                v-on:reload="getObjectDetails()"
                                v-model="formData.objectDetailIds" 
                                value-field="objectDetailsId" 
                                display-field="name">
                                </lbselect>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="form-row" v-if="globals && globals.acl && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('CHECKLIST')">
                            <inputvalidation :formerror="formError" name="checkListId">
                                <lbselect 
                                :empty="true"
                                :list="checkList.root" 
                                :total-count="checkList.totalCount"
                                :pagination="checkListPagination"
                                v-on:reload="getCheckList()"
                                v-model="formData.checkListId" 
                                value-field="checkListId" 
                                display-field="name">
                                </lbselect>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
          </div>
          </div>
            <div class="text-center mt-lg mb-lg">
                <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
                <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
            </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/building_detail/BuildingDetail.js';
import SubCompaniesApi from '@/api/admin/UserSubCompanies';
import CompaniesApi from '@/api/admin/UserCompanies';
import ObjectDetailsApi from '@/api/building_detail/ObjectDetails.js';
import CheckListApi from '@/api/check_list/CheckList.js';

export default
{
    name: 'BuildingDetailForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            userSubCompanies: {},
            userCompanies: {},
            objectDetails: {},
            checkList: {},
            formError: {},        
            formData: null,
            objectDetailsPagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
            checkListPagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        async submitData(item)
      {
          const me = this;
            try
            {
                if (typeof item.buildingDetailId !== 'undefined')
                {
                    item.id = item.buildingDetailId;
                    delete (item.buildingDetailId);
                }

                const val = await Api.save(item);

                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.close();
                }
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
      },
        async getCompanies()
      {
          const me = this;
          try
          {
              const data = await CompaniesApi.selectRow({start:0, limit: 5000});
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.userCompanies = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getSubCompanies()
      {
          const me = this;
          try
          {
              const data = await SubCompaniesApi.selectRow({start:0, limit: 5000});
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.userSubCompanies = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getCheckList()
      {
          const me = this;
          try
          {
              const data = await CheckListApi.selectRow(me.getCheckListPagination);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.checkList = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getObjectDetails()
      {
          const me = this;
          try
          {
              const data = await ObjectDetailsApi.selectRow(me.getObjectDetailsPagination);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.objectDetails = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
        close()
        {
            const me = this;
            me.newuser = false;
            me.formData = null;
            me.formError = {};
            me.userSubCompanies = {};
            me.userCompanies = {};
            me.objectDetails = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getCompanies();
                await me.getSubCompanies();
                await me.getObjectDetails();
                await me.getCheckList();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getObjectDetailsPagination()
        {
            const me = this;
            const data = { ...me.objectDetailsPagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getCheckListPagination()
        {
            const me = this;
            const data = { ...me.checkListPagination };
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
};
</script>
